import styled from '@emotion/styled'
import { theme } from 'styles/theme/hav-theme'

export const Wrapper = styled.div`
  display: grid;
  width: 100%;
  padding: ${theme.spacing.md};
`
